import { createContext, useContext, useEffect, useState, useCallback } from "react";

const PrefsContext = createContext(null);

const KEY = "portal_prefs_v1";

const DEFAULTS = {
  theme: "auto",        // light | dark | auto
  no_molestar_fin_semana: false,
  notif_horario_desde: "09:00",
  notif_horario_hasta: "20:00",
  tamano_fuente: "normal", // v8.5.60 · piel · normal | grande | extra (antes booleano fuente_grande)
  idioma: "es-PY",      // futuro: en, pt
};

function loadPrefs() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return DEFAULTS;
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch { return DEFAULTS; }
}

function savePrefs(p) {
  try { localStorage.setItem(KEY, JSON.stringify(p)); } catch {}
}

export function PrefsProvider({ children }) {
  const [prefs, setPrefs] = useState(loadPrefs);

  // Aplicar dark mode al <html>
  useEffect(() => {
    const apply = () => {
      const root = document.documentElement;
      let isDark = false;
      if (prefs.theme === "dark") isDark = true;
      else if (prefs.theme === "light") isDark = false;
      else isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      root.classList.toggle("dark", isDark);
    };
    apply();
    if (prefs.theme === "auto") {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      mq.addEventListener("change", apply);
      return () => mq.removeEventListener("change", apply);
    }
  }, [prefs.theme]);

  // Tamaño de fuente
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("fuente-grande", prefs.tamano_fuente === "grande");
    root.classList.toggle("fuente-extra", prefs.tamano_fuente === "extra");
  }, [prefs.tamano_fuente]);

  const update = useCallback((patch) => {
    setPrefs(p => {
      const next = { ...p, ...patch };
      savePrefs(next);
      return next;
    });
  }, []);

  return (
    <PrefsContext.Provider value={{ prefs, update }}>
      {children}
    </PrefsContext.Provider>
  );
}

export function usePrefs() {
  return useContext(PrefsContext) || { prefs: DEFAULTS, update: () => {} };
}
